export default function video() {
    const videoPlayer = <HTMLVideoElement>document.getElementById('video');
    if (!videoPlayer) {
        return;
    }
    const play = document.getElementById('play');
    if (!play) {
        return;
    }
    const videoPlayer2 = <HTMLVideoElement>document.getElementById('video2');
    if (!videoPlayer2) {
        return;
    }
    const play2 = document.getElementById('play2');
    if (!play2) {
        return;
    }

    play.addEventListener('click', function () {
        play.classList.add('none');
        videoPlayer.play();
        /*    videoPlayer.firstChild.nodeValue = 'Pause';*/
    });

    play2.addEventListener('click', function () {
        play2.classList.add('none');
        videoPlayer2.play();
        /*    videoPlayer2.firstChild.nodeValue = 'Pause';*/
    });

    videoPlayer.addEventListener('click', function () {
        play.classList.remove('none');
        videoPlayer.pause();
        /*    videoPlayer.firstChild.nodeValue = 'Play';*/
    });

    videoPlayer2.addEventListener('click', function () {
        play2.classList.remove('none');
        videoPlayer2.pause();
        /*    videoPlayer2.firstChild.nodeValue = 'Play';*/
    });
}
